import { ADDITIONAL_FIELDS_ALL } from "../../../shared/additional-fields";
import { EOrderVehicle } from "./LanguagePack/translatedFields";
import { Stack } from "@mui/material";
import { ContractField } from "./common";
import { settingsPreviewVehicleData } from "./settings-preview-vehicle-data";
import { centsToLocalString } from "../../../shared/money";

export default function ContractProduct({
  item,
  selectedLanguage,
  contractSettings,
  reservation,
}) {
  const additionalServices = reservation?.additionalServices;
  const fields = EOrderVehicle[selectedLanguage];
  const as = reservation?.additionalServices ?? [];

  const enabledServices =
    reservation?.additionalServices?.map((reservationService) => {
      const service = additionalServices?.find(
        (as) => as.id === reservationService.key
      );
      return {
        ...reservationService,
        ...service,
      };
    }) ?? [];
  console.log("item", item);

  const itemData = item;
  const deductible = centsToLocalString(item?.deductible);

  const includedDistance =
    enabledServices.findIndex((as) => as.category === "distance") > -1
      ? enabledServices?.find((as) => as.category === "distance").description
      : itemData?.includedDistance ?? "";

  const exportLicense = enabledServices?.find(
    (as) => as.key === "exportLicense" || as.type === "EXPORT_LICENSE"
  );
  const exportCountry =
    exportLicense?.details || fields.EXPORT_LICENSE_NO_DETAILS;

  const exportLabel = exportLicense
    ? fields.EXPORT_LICENSE_CLEARANCE + exportCountry
    : fields.EXPORT_LICENSE_NO_CLEARANCE;
  //@ts-ignore
  const powerType = getPowerType(itemData?.powerType, reservation?.language);

  // if registration plate is hidden, add "or equivalent" to the vehicle name
  const nameField = getProductName(item, contractSettings, fields);

  // @ts-ignore
  const insuranceData = reservation?.insuranceData?.providerCompany
    ? // @ts-ignore
      `Vakuutusyhtiö: ${reservation?.insuranceData?.providerCompany}, Laskutuslupa: ${reservation?.insuranceData?.billingPermitCode}, asiakkaan rekisterinumero: ${reservation?.customerCarRegistrationPlate} `
    : "";

  return (
    <Stack flex={1}>
      <Stack
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "5px",
          padding: "5px",
        }}
      >
        <Stack direction={"row"}>
          <ContractField
            sx={{ maxWidth: "100px" }}
            label={fields.REGISTRATION_NUMBER}
            value={itemData?.registrationPlate}
            visibility={!!contractSettings.showRegistrationPlateField}
          />
          <ContractField
            label={fields.NAME}
            value={nameField}
            visibility={true}
          />
        </Stack>
        <Stack direction={"row"}>
          <ContractField
            label={fields.MILEAGE_INCLUDED}
            value={includedDistance}
            visibility={!!contractSettings.showVehicleMileage}
          />
        </Stack>

        <Stack direction={"row"}>
          <ContractField
            label={fields.POWERTYPE}
            value={powerType}
            visibility={!!contractSettings.showVehicleFuelFields}
          />
          <ContractField
            label={fields.FUEL_ON_DELIVERY}
            value={""}
            visibility={!!contractSettings.showVehicleFuelFields}
          />
          <ContractField
            label={fields.FUEL_ON_RETURN}
            value={""}
            visibility={!!contractSettings.showVehicleFuelFields}
          />
        </Stack>

        <Stack direction={"row"}>
          <ContractField
            label={`${fields.COLLISION_DAMAGE_WAIVER} ${fields.DEDUCTIBLE}`}
            value={deductible}
            visibility={!!contractSettings.showDeductibleField}
          />
          <ContractField
            label={`${fields.THEFT_PROTECTION} ${fields.DEDUCTIBLE}`}
            value={deductible}
            visibility={!!contractSettings.showDeductibleField}
          />
          <ContractField
            label={fields.EXPORT_LICENSE_LABEL}
            value={exportLabel}
            visibility={!!contractSettings.showExportField}
          />
        </Stack>
        <ContractField
          label={fields.EXTRAINFO}
          value={`${itemData?.extraInfo ?? ""} ${insuranceData}`}
          visibility={!!contractSettings.showVehicleExtraInfo}
        />
      </Stack>
    </Stack>
  );
}

function calcMileage(start, end) {
  if (start && end) {
    return end - start;
  }
  return null;
}

const getProductName = (item, contractSettings, fields) => {
  if (!item) return null;

  if (item?.id === "settings-preview-reservation-vehicle") {
    return settingsPreviewVehicleData?.name;
  }

  if (contractSettings.contractProductTitle === "vehicle") {
    return item?.name;
  }
  if (contractSettings?.contractProductTitle === "exampleModel") {
    return `${item?.name} ${fields.VEHICLE_OR_EQUIVALENT_LABEL}`;
  }

  /* 
   contractSettings.contractProductTitle === "vehicle"
      ? itemData?.name
      : itemData?.name
      ? `${itemData?.name} ${fields.VEHICLE_OR_EQUIVALENT_LABEL}`
      : "Tuote nimi - tai vastaava";
  
  */
};

const getPowerType = (powerType, selectedLanguage) => {
  const translatedPowerType = ADDITIONAL_FIELDS_ALL?.find(
    (field) => field.key === "powerType"
  )?.optionsT?.[selectedLanguage]?.[powerType];
  return translatedPowerType;
};
